import { DocumentNode, gql } from '@apollo/client';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  StackDivider,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { LikesModal_ReactionFragment } from './graphql-types/LikesModal_ReactionFragment';

import { MemberItem } from './components/MemberItem';

export const LikesModal: React.FC<
  Omit<ModalProps, 'children'> & {
    reactions: LikesModal_ReactionFragment[];
  }
> & { reactionFragment: DocumentNode } = ({ reactions, ...modalProps }) => {
  return (
    <Modal size="xl" {...modalProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Likes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack divider={<StackDivider />} spacing="4" pb="4">
            {reactions.map((reaction) =>
              reaction.user ? (
                <MemberItem
                  key={reaction._id}
                  member={reaction.user}
                  width="full"
                />
              ) : null
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

LikesModal.reactionFragment = gql`
  fragment LikesModal_ReactionFragment on Reaction {
    _id
    user {
      _id
      ...MemberItem_UserFragment
    }
  }
  ${MemberItem.userFragment}
`;
